module.exports = __webpack_public_path__ + "img/num5.ce1d31f2.png";